import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=00fbccef"
import script from "./base-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-dialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=00fbccef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports